<template>
  <div class="pool-body__row" @click="emit('click')">
    <span class="pool-body__row-label">{{ label }}</span>
    <span class="pool-body__row-value">
      <template v-if="value">
        {{ value }}
      </template>
      <slot />
    </span>
  </div>
  <div class="divider" />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

interface IProps {
  label?: string;
  value?: string;
}

const props = defineProps<IProps>();

const emit = defineEmits(['click']);

const { label, value } = toRefs(props);
</script>

<style lang="scss" scoped src="./style.scss" />
